import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { SidebarCollapsingNavList, SidebarCollapsingNavListItem } from '@src/components/sco/SidebarCollpasingNavList';
import { gql } from '@src/lib/gql';
import { useMemo } from 'react';
import { LuBook, LuGraduationCap, LuHouse, LuLibrary, LuPodcast, LuVideo, LuVideotape } from 'react-icons/lu';
type EducationSidebarCollapsingNavListProps = {
  collapsed?: boolean;
};

/**
 * Education left-rail section list (Home, Courses, Articles, …).
 * Builds {@link SidebarCollapsingNavListItem}s and renders {@link SidebarCollapsingNavList}
 * — same primitive as live `/events` nav.
 *
 * Courses nests content-track links when track data is available.
 */
export const EducationSidebarCollapsingNavList = props => {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
    query EducationSidebarContentTracks {
      contentTracks(orderBy: title_ASC, where: { type_in: [Bootcamp, Course] }) {
        id
        title
        slug
        type
      }
    }
  `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const contentTracksQuery = useQuery(t0);
  contentTracksQuery.data?.contentTracks;
  let t1;
  if ($[1] !== contentTracksQuery.data?.contentTracks) {
    t1 = contentTracksQuery.data?.contentTracks?.map(_temp) ?? [];
    $[1] = contentTracksQuery.data?.contentTracks;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const courseItems = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      title: "Education",
      icon: _temp2,
      href: "/education",
      activeExact: true
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== courseItems) {
    t3 = {
      title: "Courses",
      icon: _temp3,
      href: "/courses",
      ...(courseItems.length > 0 ? {
        items: courseItems
      } : {})
    };
    $[4] = courseItems;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      title: "Articles",
      icon: _temp4,
      href: "/articles"
    };
    t5 = {
      title: "Founder Interviews",
      icon: _temp5,
      href: "/founder-interviews"
    };
    t6 = {
      title: "Podcast",
      icon: _temp6,
      href: "/podcast"
    };
    t7 = {
      title: "Videos",
      icon: _temp7,
      href: "/videos"
    };
    t8 = {
      title: "Playbooks",
      icon: _temp8,
      href: "/playbooks"
    };
    t9 = {
      title: "Lexicon",
      icon: _temp9,
      href: "/lexicon"
    };
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t3) {
    t10 = [t2, t3, t4, t5, t6, t7, t8, t9];
    $[12] = t3;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const items = t10;
  let t11;
  if ($[14] !== items || $[15] !== props.collapsed) {
    t11 = <SidebarCollapsingNavList collapsed={props.collapsed} defaultIcon={LuHouse} defaultTitle="Education" items={items} />;
    $[14] = items;
    $[15] = props.collapsed;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
};
function _temp(track) {
  return {
    title: track.title,
    href: `/${track.type === "Sprint" ? "sprints" : "courses"}/${track.slug}`
  };
}
function _temp2() {
  return <LuHouse />;
}
function _temp3() {
  return <LuGraduationCap />;
}
function _temp4() {
  return <LuBook />;
}
function _temp5() {
  return <LuVideotape />;
}
function _temp6() {
  return <LuPodcast />;
}
function _temp7() {
  return <LuVideo />;
}
function _temp8() {
  return <LuBook />;
}
function _temp9() {
  return <LuLibrary />;
}